import React from "react";
import { AppBar, Toolbar, Box } from "@mui/material";

import logo from "../assets/mealno-brand-logo.svg";

export default function Header() {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: "#F8D548",
        top: 0,
        margin: 0,
        padding: 0
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: "56px !important",
          padding: "0 16px !important",
          margin: 0
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Mealno Logo"
          sx={{
            height: 30,
            width: 120,
            objectFit: "contain",
          }}
        />
      </Toolbar>
    </AppBar>
  );
}